import { createAuthenticatedClient } from "../interceptors/tmobile-http-client";

const { VITE_API_BASE_URL_MEG } = typeof import.meta !== 'undefined' ? import.meta.env : process.env;


export const httpGetVerifyClrEnrlmnt = async (sessionToken) => {
  const path = `/verify/${sessionToken}`;
  const client = await createAuthenticatedClient(VITE_API_BASE_URL_MEG, 'get', path);
  return client.get(path);
};

export const httpGetRedirectClrEnrlmnt = async () => {
  const client = await createAuthenticatedClient(VITE_API_BASE_URL_MEG, 'get', '/redirect');
  return client.get('/redirect');
};
